export var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/node_modules/dnd-core/dist/esm/interfaces.js
// module id = 821
// module chunks = 0